"use client";

import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function SecureYourTable() {
  const contactInfo = [{
    icon: <Phone className="size-6" />,
    label: "Phone",
    value: "+60 19 327 0771",
    subValue: "Whatsapp/Call",
    link: "tel:+60193887202",
    dataIndex: 0
  }, {
    icon: <Mail className="size-6" />,
    label: "Email",
    value: "shkazrin@gmail.com",
    subValue: "Professional Inquiry",
    link: "mailto:shaik49@gmail.com",
    dataIndex: 1
  }, {
    icon: <MapPin className="size-6" />,
    label: "Address",
    value: "PG-32, Perdana Shopping Centre",
    subValue: "Damansara Perdana, PJ",
    link: "https://maps.google.com",
    dataIndex: 2
  }, {
    icon: <Clock className="size-6" />,
    label: "Service Hours",
    value: "Mon - Fri: 9:00 AM - 6:00 PM",
    subValue: "Closed on Weekends",
    link: null,
    dataIndex: 3
  }];
  return <section data-section-id="224084" id="send-a-message" className="relative bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden flex items-center justify-center min-h-[80vh]">
      <div className="absolute inset-0 z-0 bg-cover bg-center opacity-20 grayscale bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_office_interior.png)]" aria-hidden="true" />
      
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-background via-background/90 to-background" />

      <div className="relative z-10 w-full max-w-5xl mx-auto">
        <div className="bg-secondary/10 backdrop-blur-xl border border-primary/20 p-8 md:p-12 shadow-4xl relative overflow-hidden rounded-none">
          
          <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-primary/40" />
          <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-primary/40" />
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-primary/40" />
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-primary/40" />

          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-foreground mb-4 tracking-tight">
              Contact Our Firm
            </h2>
            <p className="text-muted-foreground max-w-lg mx-auto font-default">
              We listen, analyze and solve. Reach out to our legal experts for a professional consultation regarding your matter.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map(item => <div key={item.label} data-index={item.dataIndex} className="group relative p-6 bg-secondary/20 border border-primary/10 hover:border-primary/40 transition-all duration-300 rounded-none flex flex-col items-center text-center">
                <div className="mb-4 p-3 rounded-none bg-primary/10 text-primary group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <h3 className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">
                  {item.label}
                </h3>
                {item.link ? <Link to={item.link} className="text-foreground font-medium hover:text-primary transition-colors break-all">
                    {item.value}
                  </Link> : <span className="text-foreground font-medium">{item.value}</span>}
                <p className="text-xs text-muted-foreground mt-1 italic">
                  {item.subValue}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}